"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
/**
 * @deprecated Use {@link WCAGTextAreaField} instead.
 */
class TextAreaField extends fmko_ts_common_1.Widget {
    constructor(element) {
        super();
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        if (!element) {
            this.element = document.createElement("textarea");
        }
        else {
            this.element = element;
        }
        this.element.addEventListener("focus", () => this.getArea().select());
    }
    getArea() {
        return this.element;
    }
    setValue(value, fireEvents = false) {
        value = value || "";
        const oldValue = this.getArea().value;
        if (value !== oldValue) {
            this.getArea().value = value;
            if (fireEvents) {
                fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, oldValue, value);
            }
        }
    }
    getValue() {
        return this.getArea().value;
    }
    addValueChangeHandler(handler) {
        if (!this.valueChangeHandlerInitialized) {
            this.valueChangeHandlerInitialized = true;
            this.element.addEventListener("change", (e) => {
                fmko_ts_common_1.ValueChangeEvent.fire(this, this.getValue());
            });
        }
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    addKeyUpHandler(handler) {
        this.getArea().addEventListener("keyup", handler);
    }
    addPasteHandler(handler) {
        this.getArea().addEventListener("paste", handler);
    }
    setEnabled(enabled, useNew) {
        this.getArea().disabled = !enabled;
        if (useNew) {
            this.element.classList.toggle("disabled", !enabled);
        }
        else if (enabled) {
            this.element.className = this.element.className.replace(" disabled", "");
        }
        else {
            this.element.className += " disabled";
        }
    }
    /**
     * Clears the specified time.
     */
    clearValue() {
        this.getArea().value = null;
    }
    /* from Focusable interface. */
    getTabIndex() {
        return this.element.tabIndex;
    }
    /* from Focusable interface. */
    setTabIndex(tabIndex) {
        this.element.tabIndex = tabIndex;
    }
    /* from Focusable interface. */
    setAccessKey(key) {
        this.element.accessKey = key;
    }
    /* from Focusable interface. */
    setFocus(focused) {
        if (focused) {
            this.element.focus();
        }
        else {
            this.element.blur();
        }
    }
    setRows(rows) {
        this.getArea().rows = rows;
    }
}
exports.default = TextAreaField;
//# sourceMappingURL=TextAreaField.js.map